import './image.sass';

export { default } from './image';
